import { render, staticRenderFns } from "./asignarRecursosExternos.vue?vue&type=template&id=d0913a06"
import script from "./asignarRecursosExternos.vue?vue&type=script&lang=js"
export * from "./asignarRecursosExternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports